export default function (contents) {
  return {
    type: 'OPEN_MIDDLEBAR',
    contents,
  }
}